import * as React from 'react'

export function useTooltipActiveStateControls() {
  const [isActive, setIsActive] = React.useState(false)
  return React.useMemo(
    () => ({
      isActive,
      chartWrapperActiveStateControlsProps: {
        /**
         * Fix a problem with chart tooltip not hiding correctly on mouse leave
         * See: https://github.com/recharts/recharts/issues/2726
         */
        onMouseEnter: () => {
          setIsActive(true)
        },
        onMouseLeave: () => {
          setIsActive(false)
        },
      },
    }),
    [isActive]
  )
}
